import { render, staticRenderFns } from "./ProcessosInativosAnm.vue?vue&type=template&id=40348c18&lang=pug"
import script from "./ProcessosInativosAnm.vue?vue&type=script&lang=js"
export * from "./ProcessosInativosAnm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports